import { formatLiveClock } from 'pages/data-import/utils';
import { TiktokIdCell, UidCell } from '../components/cells';
import IssueTable, { IssueField } from '../components/issue-table';
import { UnmatchedRow } from '../types';
import { useIssueList } from '../use-issue-list';
import { formatCount, toCount } from '../utils';

const FIELDS: IssueField<UnmatchedRow>[] = [
  {
    key: 'tiktokUsername',
    title: 'TikTok ID',
    width: 220,
    render: (row) => <TiktokIdCell username={row.tiktokUsername} />,
  },
  {
    key: 'tiktokUid',
    title: 'UID',
    width: 200,
    render: (row) => <UidCell uid={row.tiktokUid} />,
  },
  {
    key: 'groupName',
    title: 'Nhóm',
    width: 180,
    render: (row) => row.groupName || '—',
  },
  {
    key: 'diamonds',
    title: 'KC',
    width: 140,
    align: 'right',
    render: (row) => formatCount(row.diamonds ?? 0),
  },
  {
    key: 'liveSeconds',
    title: 'Giờ LIVE',
    width: 140,
    align: 'right',
    render: (row) => formatLiveClock(toCount(row.liveSeconds)),
  },
];

const rowKey = (row: UnmatchedRow) => String(row.tiktokUid);

/** Tab "Chưa có tài khoản": UID có số liệu trong giai đoạn mới nhất nhưng chưa gắn tài khoản app. */
const UnmatchedTab = () => {
  const list = useIssueList<UnmatchedRow>(
    'unmatched',
    'Không tải được danh sách Chưa có tài khoản'
  );
  return (
    <IssueTable
      list={list}
      fields={FIELDS}
      rowKey={rowKey}
      searchPlaceholder="Tìm TikTok ID hoặc UID"
      searchLabel="Tìm theo TikTok ID hoặc UID"
      note={
        <>
          UID có số liệu trong giai đoạn mới nhất nhưng chưa có tài khoản nào trong app gắn UID
          này. Số liệu vẫn được lưu và lên Bảng xếp hạng bằng tên TikTok.
        </>
      }
    />
  );
};

export default UnmatchedTab;
